module.exports = __webpack_public_path__ + "static/media/30-Hrverk.70dade26.mp3";